import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jindu_1",
  "use": "icon-jindu_1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jindu_1\"><path d=\"M256.05 255.953h512.099v64.044H256.05zm256.233 256.146v-63.89H256.05v63.918zM256.05 639.965h448.087v63.919H256.05zM127.99 127.99l.035 767.649h768.149v32.58-96.498H192.037V127.99\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol